import React, { Component } from 'react';
import FileTransfer from './FileTransfer';
import moment from 'moment';
import {
  getFilesFromBlob,
  deleteFileFromBlob,
  requestFileFromInstrument,
  requestLogFileFromInstrument,
  getFileTransferConfig,
  getReadOnlyBlobSasToken,
  getBlobUrlWithSasToken,
  notifyInstrument,
} from './FileTransfer.actions';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import Store from '../../../../redux/Store';

import { connect } from 'react-redux';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import BlobUploadUtils from '../../../../common/utils/BlobUploadUtils';

class FileTransferContainer extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      fileInput: '',
      fileName: '',
      uploadCompleted: 0,
      downloadFilePath: '',
      dateFrom: moment().utc().startOf('day'),
      dateTo: moment().utc().startOf('day').add(1, 'days'),
      singleFileRequestFileList: [],
      dateRangeFileRequestFileList: [],
      isFetching: false,
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
    };

    this._handleSingleFileSelection = this._handleSingleFileSelection.bind(this);
    this._handleDateRangeFileSelection = this._handleDateRangeFileSelection.bind(this);
    this._handleDateRangePathValueChange = this._handleDateRangePathValueChange.bind(this);

    this._onClickRequestLogFile = this._onClickRequestLogFile.bind(this);
  }

  componentDidMount() {
    this.setState({ isFetching: true }, () => this._init());
  }

  _init = () => {
    const { instrument } = this.props;
    let files = null;

    getFilesFromBlob(instrument.SerialNumber)
      .then((res) => {
        files = res.body;
        return getFileTransferConfig(instrument.SerialNumber);
      })
      .then((res) => {
        let singleFileRequests = [],
          dateRangeFileRequests = [];

        if (res.body != null) {
          singleFileRequests = res.body.singleFileRequests;
          singleFileRequests.map((obj) => {
            obj.Selected = obj.Type === 'NoUserInput';
            return obj;
          });

          dateRangeFileRequests = res.body.dateRangeFileRequests;
          dateRangeFileRequests.map((obj) => {
            obj.Selected = obj.Type === 'NoUserInput';
            return obj;
          });
        }

        this.setState({
          data: files,
          singleFileRequestFileList: singleFileRequests,
          dateRangeFileRequestFileList: dateRangeFileRequests,
          isFetching: false,
        });
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to load files.',
          })
        );
      });
  };

  componentDidUpdate(prevProps) {
    if (
      typeof this.props.transferProgressMessage !== 'undefined' &&
      JSON.stringify(prevProps.transferProgressMessage) !=
        JSON.stringify(this.props.transferProgressMessage)
    ) {
      this._handleTransferProgressMessage(this.props.transferProgressMessage);
    } else if (prevProps.instrument.SerialNumber != this.props.instrument.SerialNumber) {
      this.setState({ isFetching: true }, () => this._init());
    }
  }

  _handleTransferProgressMessage = (message) => {
    const { FileName, FileSize, BytesTransferred, Status } = JSON.parse(message.data);
    if (Status === 'Failed') {
      Store.dispatch(
        showSnackbar({
          type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
          message: `The requested file is larger than ${Constants.FILE_TRANSFER_MAX_SIZE_MB} MB and cannot be transferred.`,
        })
      );
    }
    let newData = Object.assign([], this.state.data);
    let elIndex = newData.findIndex((file) => file.blobLink === FileName);
    if (elIndex === -1) {
      getFilesFromBlob(this.props.instrument.SerialNumber).then((res) => {
        this.setState({ data: res.body });
      });
    }

    let statusLabel = Status;
    if (Status === 'Transfer to instrument' || Status === 'Transfer from instrument') {
      const percentage = Math.round((BytesTransferred / FileSize) * 100);
      statusLabel = Status.concat(' ' + percentage + '%');
    }
    newData[elIndex] = {
      ...newData[elIndex],
      status: statusLabel,
    };
    this.setState({ data: newData });
  };

  _uploadProgress = (event) => {
    if (event && event.lengthComputable) {
      if (event.percent >= 100) {
        this.setState({ uploadCompleted: 100 });
      } else {
        this.setState({ uploadCompleted: event.percent });
      }
    }
  };

  _onClickDelete = (blobLink, displayAddress) => {
    this.setState({
      messageToConfirm: `Are you sure you want to remove the file ${displayAddress} ?`,
      showConfirmDialog: {
        title: `Remove file`,
        show: true,
        action: () => this._onConfirmDeleteBlob(blobLink),
        cancel: this._onCancelDeleteBlob,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteBlob = (blobLink) => {
    const { instrument } = this.props;
    deleteFileFromBlob(blobLink)
      .then((res) => {
        getFilesFromBlob(instrument.SerialNumber).then((res) => {
          this.setState({
            data: res.body,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              action: () => {},
              cancel: () => {},
              disableMainAction: false,
            },
          });
        });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'File deleted successfully.',
          })
        );
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to delete the file. Please try again.',
          })
        );
      });
  };

  _onCancelDeleteBlob = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _formatUploadFileName = (fileName) => {
    return fileName.replace(/ /g, '_');
  };

  _onClickFileBrowse = ({ target }) => {
    this.setState({ uploadCompleted: 0 });
    let fileFullPath = '';
    if (this.state.fileInput.files[0]) {
      fileFullPath = this.state.fileInput.files[0].name;
      fileFullPath = this._formatUploadFileName(fileFullPath);
    }
    this.setState({ fileName: fileFullPath });
  };

  _setUploadProgress = (value) => {
    this.setState({ uploadCompleted: value });
  };

  _onClickUploadAsync = async () => {
    let file = this.state.fileInput.files[0];
    let fileName = this._formatUploadFileName(file.name);

    const { instrument } = this.props;

    if (this.state.fileInput.files.length != 1) {
      this._showErrorMessage('Please select a file to upload.');
      return;
    }

    try {
      const blobUrlRes = await getBlobUrlWithSasToken(instrument.SerialNumber, fileName);
      const blockBlobClient = await BlobUploadUtils.createBlockBlobClient(
        blobUrlRes.body.storageUrlWithBlobSasToken
      );
      var doesBlobExist = await blockBlobClient.exists();
      if (doesBlobExist === true) {
        this._showErrorMessage('File with the same name already exists.');
      } else {
        await BlobUploadUtils.uploadToBlobStorage(blockBlobClient, file, this._setUploadProgress);
        await notifyInstrument(blockBlobClient.url, instrument.SerialNumber);
        const res = await getFilesFromBlob(instrument.SerialNumber);
        this.setState({
          data: res.body,
        });

        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message:
              'File upload request sent. Please note that transferring the file may take several minutes.',
          })
        );
      }
    } catch (err) {
      this._handleUploadError(err);
    }
  };

  _handleUploadError = (err) => {
    const errorMessage =
      err && err.response && err.response.body && err.response.body.Message
        ? err.response.body.Message
        : 'Failed to upload the file.';
    this._showErrorMessage(errorMessage);
  };

  _showErrorMessage = (message) => {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: message,
      })
    );
  };

  _onClickRequestFile = () => {
    const { instrument } = this.props;
    if (this._isFileConfigSelected(this.state.singleFileRequestFileList)) {
      requestFileFromInstrument(
        instrument.SerialNumber,
        this._getSelectedFileConfigs(this.state.singleFileRequestFileList)
      )
        .then((res) => {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
              message:
                'File request sent. Please note that transferring the file may take several minutes.',
            })
          );
          return getFilesFromBlob(instrument.SerialNumber);
        })
        .then((res) => {
          this.setState({
            data: res.body,
          });
        })
        .catch((res) => {
          let errorMessage =
            res.status === 400
              ? res.response.body.Message
              : 'Failed to download the file from the instrument.';
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message: errorMessage,
            })
          );
        });
    } else {
      Store.dispatch(
        showSnackbar({
          type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
          message: 'Select at least one type of file you want to download.',
        })
      );
    }
  };

  _handleFilePathValueChange = (newValue) => {
    this.setState({ downloadFilePath: newValue });
  };

  _handleDateChange = (dateFrom, dateTo) => {
    if (dateFrom) {
      this.setState({ dateFrom });
    } else {
      this.setState({ dateTo });
    }
  };

  _onClickRequestLogFile = () => {
    const { instrument } = this.props;

    if (this._isFileConfigSelected(this.state.dateRangeFileRequestFileList)) {
      requestLogFileFromInstrument(
        instrument.SerialNumber,
        this.state.dateFrom.toDate().toISOString(),
        moment(this.state.dateTo).add(1, 'day').toDate().toISOString(),
        this._getSelectedFileConfigs(this.state.dateRangeFileRequestFileList)
      )
        .then((res) => {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
              message:
                'File request sent. Please note that transferring the file may take several minutes.',
            })
          );
          return getFilesFromBlob(instrument.SerialNumber);
        })
        .then((res) => {
          this.setState({
            data: res.body,
          });
        })
        .catch((res) => {
          let errorMessage =
            res.status === 400
              ? res.response.body.Message
              : 'Failed to download the file from the instrument.';
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message: errorMessage,
            })
          );
        });
    } else {
      Store.dispatch(
        showSnackbar({
          type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
          message: 'Select at least one type of file you want to download.',
        })
      );
    }
  };

  _handleSingleFileSelection = (index) => {
    const newSingleFileRequestFiles = this.state.singleFileRequestFileList.slice(0);
    newSingleFileRequestFiles.filter((file) => file.Type === 'Checkbox')[index].Selected =
      !newSingleFileRequestFiles.filter((file) => file.Type === 'Checkbox')[index].Selected;
    this.setState({ singleFileRequestFiles: newSingleFileRequestFiles });
  };

  _handleDateRangeFileSelection = (index) => {
    const newDateRangeFileRequestFileList = this.state.dateRangeFileRequestFileList.slice(0);
    newDateRangeFileRequestFileList[index].Selected =
      !newDateRangeFileRequestFileList[index].Selected;
    this.setState({ dateRangeFileRequestFileList: newDateRangeFileRequestFileList });
  };

  _handleFilePathValueChange = (value, index) => {
    const newSingleFileRequestFiles = this.state.singleFileRequestFileList.slice(0);
    newSingleFileRequestFiles.filter((file) => file.Type === 'TextField')[index].FileNames = value;
    newSingleFileRequestFiles.filter((file) => file.Type === 'TextField')[index].Selected = !!value;
    this.setState({ singleFileRequestFileList: newSingleFileRequestFiles });
  };

  _handleDateRangePathValueChange = (value, index) => {
    const newDateRangeFileRequestFiles = this.state.dateRangeFileRequestFileList.slice(0);
    newDateRangeFileRequestFiles.filter((file) => file.Type === 'TextField')[index].FileNames =
      value;
    newDateRangeFileRequestFiles.filter((file) => file.Type === 'TextField')[index].Selected =
      !!value;
    this.setState({ dateRangeFileRequestFileList: newDateRangeFileRequestFiles });
  };

  _isFileConfigSelected = (fileConfigList) => {
    for (var i = 0; i < fileConfigList.length; i++) {
      if (fileConfigList[i].Selected) {
        return true;
      }
    }
    return false;
  };

  _getSelectedFileConfigs = (fileConfigList) => {
    let selectedFileConfigs = new Array();
    fileConfigList.forEach((element) => {
      if (element.Selected) {
        selectedFileConfigs.push(element);
      }
    });
    return selectedFileConfigs;
  };

  _onClickDownload = (blobUrl) => {
    getReadOnlyBlobSasToken(blobUrl)
      .then((res) => {
        let token = res.body;
        let pathWithToken = blobUrl + token;
        var downloadWindow = window.open(pathWithToken);
        try {
          downloadWindow.focus();
        } catch (e) {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message:
                'Download blocked by browser. Add this site to your exception list and try again.',
            })
          );
        }
      })
      .catch((err) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to download the selected file.',
          })
        );
      });
  };

  render() {
    return (
      <FileTransfer
        data={this.state}
        onClickDelete={this._onClickDelete}
        onClickFileUpload={this._onClickUploadAsync}
        onClickFileBrowse={this._onClickFileBrowse}
        onClickRequestFile={this._onClickRequestFile}
        handleFilePathValueChange={this._handleFilePathValueChange}
        handleDateChange={this._handleDateChange}
        onClickRequestLogFile={this._onClickRequestLogFile}
        singleFileRequestFileList={this.state.singleFileRequestFileList}
        handleSingleFileSelection={this._handleSingleFileSelection}
        dateRangeFileRequestFileList={this.state.dateRangeFileRequestFileList}
        handleDateRangeFileSelection={this._handleDateRangeFileSelection}
        isFetching={this.state.isFetching}
        onClickDownload={this._onClickDownload}
        showConfirmDialog={this.state.showConfirmDialog}
        messageToConfirm={this.state.messageToConfirm}
        handleDateRangePathValueChange={this._handleDateRangePathValueChange}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  transferProgressMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'FileTransferProgress')
      : null,
});

export default withRouter(connect(mapStateToProps)(FileTransferContainer));
